// Service worker registration (PWA).
export function registerSW() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  // Only register in production-like origins (not localhost CRA dev unless HTTPS).
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      /* silently ignore — offline drafts still work via localStorage */
    });
  });
}
